import React, { useMemo } from "react";
import Select from "react-select";
import { Card, Row, Col, Image } from "react-bootstrap";

const SimilarEventsSection = ({
  allEvents = [],
  selectedEvents = [],
  onChange,
}) => {
  // Prepare options for react-select
  const options = useMemo(
    () =>
      allEvents.map((event) => ({
        value: event._id || event.id,
        label: event.title,
        event,
      })),
    [allEvents]
  );

  // Get selected event objects
  const selectedEventObjs = useMemo(
    () =>
      options
        .filter((opt) => selectedEvents.includes(opt.value))
        .map((opt) => opt.event),
    [options, selectedEvents]
  );

  return (
    <div className="mb-4">
      <label className="form-label fw-bold mb-2">Similar Events</label>
      <Select
        isMulti
        options={options}
        value={options.filter((opt) => selectedEvents.includes(opt.value))}
        onChange={(selected) =>
          onChange(selected ? selected.map((s) => s.value) : [])
        }
        placeholder="Select similar events..."
        classNamePrefix="react-select"
      />
      {selectedEventObjs.length > 0 && (
        <Row className="mt-3">
          {selectedEventObjs.map((event, idx) => {
            const firstImage = Array.isArray(event.gallery) && event.gallery.length > 0 ? event.gallery[0] : null;
            return (
              <Col md={3} key={event._id || event.id} className="mb-3">
                <Card className="h-100">
                  {firstImage && (
                    <Image
                      src={firstImage}
                      alt={event.title}
                      style={{ width: "100%", height: 140, objectFit: "cover", borderTopLeftRadius: ".5rem", borderTopRightRadius: ".5rem" }}
                      className="card-img-top"
                    />
                  )}
                  <Card.Body className="p-2">
                    <div className="fw-bold mb-1">{event.title}</div>
                    <div className="small text-muted mb-1">
                      {event.location?.location || "-"}
                      {event.location?.city ? `, ${event.location.city}` : ""}
                    </div>
                    <div className="mb-1">
                      <span className="badge bg-info">
                        {event.dateType?.date || "-"}
                        {event.dateType?.endDate
                          ? ` to ${event.dateType.endDate}`
                          : ""}
                      </span>
                    </div>
                    <div className="small">
                      {event.desc?.slice(0, 60)}
                      {event.desc && event.desc.length > 60 ? "..." : ""}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export default SimilarEventsSection;
